// We use this in a few places for career total stats
export const CAREER = 'Career';
